export { default } from './Credit';
